import React from "react";
import { Link } from "react-router-dom";
import "./sudanLanding.scss";
import ClassImage from "../sudanimg/img (sudan website).png";
import { useLanguage } from "../i18n/LanguageContext";

const ACC_STATS = [
   { num: "20", label: "Organizations per year" },
   { num: "4", label: "Weeks facilitation" },
   { num: "Free", label: "Platform and program access at no cost" }
];

const AcceleratorProgram = () => {
   const { t } = useLanguage();
   return (
      <section className="sd-section sd-accelerator" id="accelerator">
         <div className="container">
            <div className="sd-acc-split">
               <div className="sd-acc-main">
                  <div className="sd-acc-head">
                     <h2>{t("Four weeks. Twenty organizations. One certificate.")}</h2>
                     <p>
                        {t(
                           "Each year, KAPorg selects up to 20 Sudanese organizations that have demonstrated commitment and readiness to join our intensive guided program — free of charge."
                        )}
                     </p>
                  </div>

                  <div className="sd-acc-stats">
                     {ACC_STATS.map((stat) => (
                        <div className="sd-acc-stat" key={stat.label}>
                           <div className="sd-acc-num">{t(stat.num)}</div>
                           <div className="sd-acc-label">{t(stat.label)}</div>
                        </div>
                     ))}
                  </div>

                  <div className="sd-acc-cta">
                     <Link to="/auth/registration" className="sd-btn sd-btn-accent">
                        {t("Apply for the 2026 program")}
                     </Link>
                     <Link to="/capacity-accelerator-program" className="sd-btn sd-btn-ghost-light">
                        {t("Learn more")}
                     </Link>
                  </div>
               </div>

               <div className="sd-acc-aside">
                  <div className="sd-cert-card">
                     <img
                        src={ClassImage}
                        alt="Members of Sudanese organizations learning together in a training session"
                     />
                     <div className="sd-cert-body">
                        <h4>{t("The KAPorg Certificate of Organizational Capacity")}</h4>
                        <p>
                           {t(
                              "Organizations that complete the program receive a certificate that demonstrates their internal initiative to build an organization capable of applying for and receiving funding, and implementing programs in the most transparent, accountable, and needs-driven ways."
                           )}
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default AcceleratorProgram;
